import PolicyContainer from './PolicyContainer';
import useTermly from './useTermly';

function Shipping () {
  useTermly();
  return (
    <PolicyContainer>
      <div name="termly-embed" data-id="514c5369-a0f9-423b-89cd-d075c4d02298" data-type="iframe" />
    </PolicyContainer>
  );
}

export default Shipping;
